module.exports = "!function(){\"use strict\";Ext.namespace(\"SF.array\"),SF.array.flatFilter=function(t,a){return Ext.flatten(t||[]).filter(a||Boolean)}}();"